/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { YearInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class YearApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'Years');
  }

  find(params?: any): Observable<YearInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<YearInterface[]>(path, httpParams);
  }

  getYears(params?: HttpParams): Observable<{ count: number; results: YearInterface[] }> {
    const path = 'search';
    return this.get(path, params);
  }

  createYear(year: YearInterface): Observable<YearInterface> {
    const path = '';
    return this.post(path, undefined, year);
  }

  updateYear(params: any, year: YearInterface): Observable<YearInterface> {
    const path = '';
    return this.put(path, params, year);
  }

  deleteById(id: number): Observable<boolean> {
    const path = `${id}`;
    return this.delete<void>(path).pipe(map(() => true));
  }
}
